module.exports = __webpack_public_path__ + "img/mo.f3a130d2.png";